<footer class="footer-holder">
  <p>Copyright &#169; <a href="https://www.kairhos.com/" target="_blank">Kairhos Labs Pvt Ltd</a>. All rights reserved.</p>
  <span class="sep"></span>
  <a>Terms</a>
  <span class="sep"></span>
  <a>Privacy</a>
  <span class="sep"></span>
  <a>Trust Center</a>
  <span class="sep"></span>
  <a>Acceptable Use Guidelines</a>
  <span class="sep"></span>
  <a>Legal &amp; Compliance</a>
  <span class="sep"></span>
  <a>Do Not Sell/Share My Personal Information</a>
  <span class="sep"></span>
  <a>Cookie Preferences</a>
</footer>
